export const baseURL = process.env.REACT_APP_BASE_URL;
export const secretKey = process.env.REACT_APP_SECRET_KEY;
export const projectName = process.env.REACT_APP_PROJECT_NAME || "";
export const bucketName = process.env.REACT_APP_BUCKET_NAME;
export const hostname = process.env.REACT_APP_AWS_HOSTNAME;
export const aws_access_key_id = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
export const aws_secret_access_key =
  process.env.REACT_APP_AWS_SECRET_ACCESS_KEY;

